// extracted by css-extract-rspack-plugin
export default {"modalRoot":"bsBF3","modalHeader":"eK6kh","modalBody":"w5FxX"};